import { createProvider } from '@nvision/services/data-provider';

import type { CarrierFilters } from '../../models';
import * as api from './api';
import { normalizeCarrierFilters, normalizeCarriers } from './normalize';

export const fetchCarriers = createProvider(
  (filters: Partial<CarrierFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchCarriers(normalizeCarrierFilters(filters), { signal }),
).andThen((res) => normalizeCarriers(res));
